import { c as _c } from "react/compiler-runtime";
import { getButtonLinkProps } from '@openclassrooms/routing';
import Typography from '@classify/react-core-components/Typography';
interface Props {
  children: string;
  to?: string;
}
export default function BreadcrumbsItem(t0) {
  const $ = _c(5);
  const {
    to,
    children
  } = t0;
  let t1;
  if ($[0] !== to) {
    t1 = to ? getButtonLinkProps(to) : {
      component: "span"
    };
    $[0] = to;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const elementProps = t1;
  let t2;
  if ($[2] !== children || $[3] !== elementProps) {
    t2 = <Typography {...elementProps} variant="subheadingSmall">{children}</Typography>;
    $[2] = children;
    $[3] = elementProps;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}